require(["common"], function() {});
define("empty", function(){});

